export class SortOption {
  label: string;
  key: string;
  value: string;
  id: number;
  code: SortOptionsEnum;
}

export enum SortOptionsEnum {
  BEST_MATCH = 'BEST_MATCH',
  PRICE_ASC = 'PRICE_ASC',
  PRICE_DESC = 'PRICE_DESC',
  NEW_ARRIVALS = 'NEW_ARRIVALS',
}

export const SortTypes: SortOption[] = [
  {
    id: 0,
    value: 'desc',
    key: 'bestMatch',
    code: SortOptionsEnum.BEST_MATCH,
    label: 'CATALOG.CATALOG_PAGE.CATALOG_TOOLBAR.SORT_TOGGLER.LABEL.BEST_MATCH_DESC',
  },
  {
    id: 2,
    value: 'asc',
    key: 'price',
    code: SortOptionsEnum.PRICE_ASC,
    label: 'CATALOG.CATALOG_PAGE.CATALOG_TOOLBAR.SORT_TOGGLER.LABEL.PRICE_HIGH',
  },
  {
    id: 3,
    value: 'desc',
    key: 'price',
    code: SortOptionsEnum.PRICE_DESC,
    label: 'CATALOG.CATALOG_PAGE.CATALOG_TOOLBAR.SORT_TOGGLER.LABEL.PRICE_LOW',
  },
  {
    id: 4,
    value: 'desc',
    key: 'createdAt',
    code: SortOptionsEnum.NEW_ARRIVALS,
    label: 'CATALOG.CATALOG_PAGE.CATALOG_TOOLBAR.SORT_TOGGLER.LABEL.NEW_ARRIVALS',
  },
];
